<div
  class="left-sidenav-wrapper"
  [class.left-sidenav-wrapper--collapsed]="shell.leftSidenavCollapsed() && device.gtSmScreen()"
>
  <div
    #leftSidenavContent
    class="left-sidenav-content ac-flex-col ac-gap-lg ac-pd-lg-md"
    (scroll)="onScroll($event)"
  >
    @if (device.isXsScreen()) { @if (user(); as user) {
      <button
        mat-icon-button
        class="ac-icon-btn-sm close-button"
        (click)="shell.toggleLeftSidenav()">
        <ac-icon iconKey="hr:xmark" [size]="20" />
      </button>

      <div class="user-details ac-flex-col ac-algn-ctr ac-gap-xs">
        <img
          [src]="
            user.avatar_url ?? ('cdnUrl' | env) + '/images/default_avatar.webp'
          "
          class="user-avatar"
          alt="user-avatar"
        />

        @if (user!.first_name || user!.last_name) {
          <span class="ac-title-lg">
            {{ user!.first_name }} {{ user?.last_name }}
          </span>
        }

        <span class="ac-body-sm ac-label">
          {{ user!.username }}
        </span>
      </div>
     }
    }

    <div class="ac-flex-col ac-gap-md">
      @for (sidenavLink of mainButtons(); track sidenavLink.label) {
        <app-left-sidenav-button
          [sidenavLink]="sidenavLink"
          [collapsed]="shell.leftSidenavCollapsed() && device.gtSmScreen()" />
      }
    </div>

    <div class="ac-flex-col ac-gap-md">
      @if (!shell.leftSidenavCollapsed() || !device.gtSmScreen()) {
        <div class="ac-flex ac-algn-ctr ac-sp-btw ac-pd-md-lg">
          <span class="ac-label-md">CASINO GAMES</span>

          <a
            class="ac-flex ac-algn-ctr ac-gap-xs"
            routerLink="/games"
            (click)="shell.toggleLeftSidenav()">
            <span class="ac-label-sm"> VIEW ALL </span>
            <ac-icon iconKey="hr:arrow_right_circle" [size]="12" />
          </a>
        </div>
      } @else {
        <div class="collapsed-divider"></div>
      }

      @for (sidenavLink of gameButtons; track sidenavLink.label) {
        <app-left-sidenav-button
          [sidenavLink]="sidenavLink"
          [collapsed]="shell.leftSidenavCollapsed() && device.gtSmScreen()" />
      }
    </div>

    @if (device.isXsScreen()) {
    <div class="ac-flex ac-algn-ctr ac-sp-btw ac-pd-md-lg">
      <span class="ac-label-sm ac-label">SUPPORT</span>
    </div>

    <div class="ac-flex-col ac-gap-xs">
      @for (sidenavLink of helpButtons; track sidenavLink.label) {
      <app-left-sidenav-button [sidenavLink]="sidenavLink" />
      }
    </div>
    } @if (device.isXsScreen() && user()) {
    <button mat-flat-button class="sign-out-btn ac-neutral" (click)="signOut()">
      Sign Out
    </button>
    }
  </div>

  <!-- Scroll blur indicator and collapse button - only shown in 'side' mode (desktop) -->
  @if (device.gtSmScreen()) {
    <div
      class="scroll-blur-indicator"
      [class.scroll-blur-indicator--visible]="showScrollIndicator()"
    ></div>

    <div class="collapse-toggle-container">
      <button
        mat-icon-button
        class="collapse-toggle-btn"
        (click)="shell.toggleLeftSidenavCollapsed()"
        [attr.aria-label]="shell.leftSidenavCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
        [attr.aria-expanded]="!shell.leftSidenavCollapsed()"
      >
        <ac-icon
          [iconKey]="shell.leftSidenavCollapsed() ? 'hr:expand' : 'hr:collapse'"
          [size]="24" />
      </button>
    </div>
  }
</div>
